import * as _ from "lodash";

import { browserHistory } from "react-router";

const replace = (location = "/", deferred = 0) => {
  _.delay(() => browserHistory.replace(location), deferred);
};

const push = (location = "/", deferred = 0) => {
  _.delay(() => browserHistory.replace(location), deferred);
};

export default { push, replace };
